import { render, staticRenderFns } from "./houseHoldInfo.vue?vue&type=template&id=bb0936d8&"
import script from "./houseHoldInfo.vue?vue&type=script&lang=js&"
export * from "./houseHoldInfo.vue?vue&type=script&lang=js&"
import style0 from "./houseHoldInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports